import React from "react";
import { isSafari } from "react-device-detect";
import { AspectRatio, Box } from "@chakra-ui/react";
import { Section, sectionSpacingY } from "components/section";
import { DecorativeBackgroundImage, FillImage } from "components/images";
import { Lottie } from "ui/lottie";
import { TextTitle } from "ui/text";
import streamingDiagram from "../../../../public/assets/platform/event-collection/event-streaming-diagram.png";
import streamingBgImage from "../../../../public/assets/platform/event-collection/event-streaming-bg.svg";
import animationData from "./event-streaming-animation.json";

const diagramRatio = 1320 / 587;

export function EventStreaming() {
  const diagramAlt =
    'An illustration of a diagram representing an "Order Completed" event and its metadata being streamed to Facebook, Salesforce, Braze, HubSpot, and Intercom.';

  return (
    <Section theme="dark" bg="new.gray.950" themeBgColor="new.gray.950" py="0" pb={sectionSpacingY}>
      <TextTitle
        theme="dark"
        size="lg"
        align="center"
        title="Real-time event streaming"
        description="Sync event data to your downstream tools, where and when you need it."
        pb={{ base: "bigger", md: "biggest" }}
      />

      {isSafari ? (
        <AspectRatio ratio={diagramRatio} w="100%" borderRadius="bigger" overflow="hidden">
          <FillImage src={streamingDiagram} alt={diagramAlt} />
        </AspectRatio>
      ) : (
        <AspectRatio
          ratio={diagramRatio}
          borderRadius={{ base: "small", md: "bigger" }}
          w="100%"
          pos="relative"
          overflow="hidden"
        >
          <Box boxSize="100%">
            <DecorativeBackgroundImage src={streamingBgImage} />

            <Lottie animationData={animationData} ratio={1120 / 386} />
          </Box>
        </AspectRatio>
      )}
    </Section>
  );
}
